import React from 'react';
import Issue from './Paper/Issue';
import './sass/App.sass';

function App() {
  return (
    <div className="App">
      <Issue></Issue>
    </div>
  );
}

export default App;
